export default {
  primary: {
    backgroundColor: 'secondary',
    color: 'light',
    border: 'solid 2px',
    borderColor: 'secondary',
    borderRadius: '0px',
    fontFamily: 'subheading',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: ['1rem', '', '1.2rem'],
    padding: '1.25rem 2.5rem',
    transition: 'all ease-in-out 0.5s',
    border: 'solid 1px white',
    ':hover': {
      backgroundColor: 'primary',
      color: 'white',
      borderColor: 'primary'
    }
  },
  secondary: {
    color: 'light',
    border: 'solid 2px',
    borderColor: 'primary',
    backgroundColor: 'primary',
    borderRadius: '0px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontFamily: 'body',
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: ['0.9rem', '', '1rem'],
    padding: '1rem',
    transition: 'all ease-in-out 0.5s',
    ':hover': {
      backgroundColor: 'secondary',
      borderColor: 'secondary'
    }
  }
}
